import { Key } from 'react';
import { appLocalStorage, EStorageNames } from '../../../../helpers/storage';
import { TColumnsState } from '../Table.types';

/**
 * Checks and updates table settings in local storage
 * @param tableName - The name/path of the table in storage
 * @param newColumns - The new columns configuration to check against existing settings
 * @returns The updated columns configuration
 */
export const checkAndUpdateTableSettings = (
  tableName: string,
  newColumns: TColumnsState[],
): TColumnsState[] => {
  const tableSettings =
    appLocalStorage.getItem(EStorageNames.tableSettings) || {};

  if (tableSettings[tableName]) {
    const existingColumns = tableSettings[tableName];
    const columnsChanged = newColumns.some(
      newCol =>
        !existingColumns.find(
          (existingCol: { key: Key; title: string }) =>
            existingCol.key === newCol.key &&
            existingCol.title === newCol.title,
        ),
    );

    if (columnsChanged) {
      tableSettings[tableName] = newColumns;
      appLocalStorage.setItem(EStorageNames.tableSettings, tableSettings);
      return newColumns;
    }
    return existingColumns;
  }

  tableSettings[tableName] = newColumns;
  appLocalStorage.setItem(EStorageNames.tableSettings, tableSettings);
  return newColumns;
};
